import { Injectable } from '@angular/core';

/** A date range as the pickers commit it; either end may be unset. */
export interface ErstelltAmRange {
  start?: string | null;
  end?: string | null;
}

/**
 * Query building shared by every surface that lists documents: the Dokumenten-Manager of the user
 * app and the Dokumente tab of the admin app. Both talk to the same `uploads` endpoint, so the
 * filters they send have to mean the same thing.
 */
@Injectable({ providedIn: 'root' })
export class DocumentManagerHelperService {
  /**
   * Builds the creation-date filter from whichever ends of the range are set.
   *
   * Each bound stands on its own: a range open at one end is a filter the user made, and the API
   * takes one operator as readily as two. Both bounds are inclusive.
   *
   * @param {ErstelltAmRange} range - The selected range, either end possibly unset
   * @returns {string[] | undefined} The operators to send, `undefined` for no range at all
   */
  public buildErstelltAmFilter(range: ErstelltAmRange): string[] | undefined {
    const bounds: string[] = [];

    if (range.start) {
      bounds.push(`$gte:${range.start}`);
    }
    if (range.end) {
      bounds.push(`$lte:${range.end}`);
    }

    return bounds.length ? bounds : undefined;
  }

  /**
   * Builds a multi-value filter as one `$in` condition.
   *
   * @param {readonly string[]} values - The selected values
   * @returns {string[] | undefined} The condition, `undefined` when nothing is selected
   */
  public buildInFilter(values: readonly string[]): string[] | undefined {
    return values.length > 0 ? [`$in:${values.join(',')}`] : undefined;
  }
}
